import {
    Grid2
} from '@mui/material';
import { useEffect, useState } from 'react';

import parse from "html-react-parser";
import { StandardPanel } from '../../../_components/panel/standard.panel';
import { MessageNotification } from '../../../_components/box/message-notification';

export function AuctionCatalogueItemView(params: { catalogueItem?: any, catalogueItemLoading: boolean }) {

    return (
        <Grid2 size={{ xs: 12 }} sx={{ '& .MuiCard-root': { margin: 0 }, '& .MuiCardContent-root': { '&:last-child': { pb: { xs: 1, sm: 2 } } } }}>
            <StandardPanel title={!!params.catalogueItem ? `[#${params.catalogueItem.lotNo}]${params.catalogueItem.product} - ${params.catalogueItem.district} - ${params.catalogueItem.totalVolume}` : !!params.catalogueItemLoading ? "Loading.." : undefined} loading={params.catalogueItemLoading}>
                {(!params.catalogueItemLoading && !!params.catalogueItem && !!params.catalogueItem?.description) &&
                    <>{parse(params.catalogueItem?.description)}</>
                }

                {(!params.catalogueItemLoading && !params.catalogueItem) &&
                    <MessageNotification message='No active catalogue item selected' />
                }
            </StandardPanel>
        </Grid2>
    )
}
